// extracted by mini-css-extract-plugin
export default {"inviteContainer":"InvitePage_inviteContainer__m9GHT","inviteText":"InvitePage_inviteText__lRhBu","dot":"InvitePage_dot__BNb0E","wave":"InvitePage_wave__uQfiS"};